module.exports = __webpack_public_path__ + "static/media/droetker.561cb53f.png";